import {useQuery} from 'react-query'
import {getRoomIdById} from './core/_request'
import {useParams} from 'react-router-dom'
import {AxiosError} from 'axios'
import {QUERIES} from '../../_metronic/helpers'
import {NotFoundIdShowPage} from '../../components/NotFoundIdShowPage'
import {HasErrorInShowPage} from '../../components/HasErrorInShowPage'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {HeaderForShowPage} from '../../components/HeaderForShowPage'
import {formatDateTime} from '../../utils/dayJs/format'
import {PageOverlayer} from '../../components/PageOverlayer'

const roomBreadcrumbs: Array<PageLink> = [
  {
    title: 'Salas',
    path: '/rooms/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const RoomShowPage = () => {
  let {id} = useParams()

  const {isLoading, data, error} = useQuery(
    `${QUERIES.ROOM_SHOW}-getById-${id}`,
    () => {
      return getRoomIdById(String(id))
    },
    {
      cacheTime: 0,
      enabled: true,
      onError: (err) => {
        console.log(err)
      },
    }
  )

  if (isLoading) {
    return <PageOverlayer />
  }

  if (error) {
    if (error instanceof AxiosError) {
      const status = error.response?.status

      switch (status) {
        case 404:
          return <NotFoundIdShowPage source='Sala' />
        default:
          return <HasErrorInShowPage />
      }
    }

    return <HasErrorInShowPage />
  }

  const {name, syncName, color, maxScheduleDate, categories, products, machines, intervals, createdAt, updatedAt} =
    data

  return (
    <>
      <PageTitle breadcrumbs={roomBreadcrumbs}>Dados da Sala</PageTitle>
      <div className='card'>
        <div className='card-body'>
          <HeaderForShowPage title='Informações da Sala' />
          <p>Nome: {name || ' '}</p>
          <p>Nome sincronização: {syncName || ' '}</p>
          <p className='d-flex align-items-center gap-2'>
            Cor: <span className='w-20px h-20px rounded d-inline-block' style={{backgroundColor: color}} />
          </p>
          <p>Range de agendamento: {maxScheduleDate} dias</p>
          <p>Categorias: {categories?.map((category) => category.name).join(', ') || '-'}</p>
          <p>Produtos: {products?.map((product) => product.name).join(', ') || '-'}</p>
          {machines?.length > 0 && (
            <p>Máquinas: {machines.map((machine) => machine.machine?.name).join(', ')}</p>
          )}
          <p className='mb-2'>Disponibilidade:</p>
          <ul>
            {intervals?.map((interval) => (
              <li key={interval.id}>
                {interval.dayOfWeekDescription}: {interval.startTime} às {interval.endTime}
              </li>
            ))}
          </ul>
          <p>Criado em: {createdAt ? formatDateTime(createdAt) : ' '}</p>
          <p>Atualizado em: {updatedAt ? formatDateTime(updatedAt) : ' '}</p>
        </div>
      </div>
    </>
  )
}
